import React from 'react'
import { ticketRowDate } from './emailTimes.js'

// The date on a ticket list row. One element for the desktop list and the
// phone list, so both pick the date the same way.
export default function TicketRowDate({ ticket, className = 'ticket-row__date' }) {
  const { text, title, isSyncTime } = ticketRowDate(ticket)
  const classes = isSyncTime ? `${className} ticket-row__date--synced` : className
  return <span className={classes} title={title}>{text}</span>
}
